import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { changeJob } from "../features/jobs/jobsSlice";

function EditJob() {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, editTitle, editType, editSalary, editDeadline } = state; // Read values passed on state
  const [title, setTitle] = useState(editTitle);
  const [type, setType] = useState(editType);
  const [salary, setSalary] = useState(editSalary);
  const [deadline, setDeadline] = useState(editDeadline);
  const editJobHandler = (e) => {
    e.preventDefault();
    dispatch(
      changeJob({
        id,
        data: { id, title, type, salary: Number(salary), deadline },
      })
    );
    navigate("../");
  };

  return (
    <>
      <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>
      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={editJobHandler}>
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="lwsJobTitle"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            >
              <option value="" hidden>
                Select Job
              </option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="lwsJobType"
              required
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              required
              value={deadline}
              onChange={(e) => setDeadline(e.target.value)}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EditJob;
